import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b60c6ba4&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=b60c6ba4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60c6ba4",
  null
  
)

export default component.exports